"use strict";

const Floorplan = () => {
    const init = () => {
        $(function() {
            var $floorplan = $('.js-floorplan');
            if($floorplan.length){
                var $floorplanImages = $floorplan.find('.js-floorplan-image');
                var $flipToggle = $floorplan.find('.js-flip-toggle');
                var $floorplanOptions = $floorplan.find('.js-floorplan-option-toggle');
                var $levels = $floorplan.find('.js-floorplan-level');
                var $levelsContainer = $floorplan.find('.js-floorplan-levels');
                var $popupTrigger = $floorplan.find('.js-floorplan-popup-trigger');

                $flipToggle.on('click', function(){
                    var level = $levels.filter('.active').data('level');
                    if($(window).outerWidth() < 992 && $levels.length){
                        var $notFlipped = $floorplanImages.filter('[data-flipped="false"][data-level="'+level+'"].mobile');
                        var $flipped = $floorplanImages.filter('[data-flipped="true"][data-level="'+level+'"].mobile');
                    }else{
                        var $notFlipped = $floorplanImages.filter('[data-flipped="false"]:not(.mobile)');
                        var $flipped = $floorplanImages.filter('[data-flipped="true"]:not(.mobile)');
                    }
                    if($notFlipped.hasClass('active')){
                        $notFlipped.removeClass('active');
                        $notFlipped.find('.image').html('');
                        $flipped.addClass('active');
                        inlineSVG($flipped);
                        if($levelsContainer.length){
                            $levelsContainer.addClass('flipped');
                        }
                    }else{
                        $flipped.removeClass('active');
                        $flipped.find('.image').html('');
                        $notFlipped.addClass('active');
                        inlineSVG($notFlipped);
                        if($levelsContainer.length){
                            $levelsContainer.removeClass('flipped');
                        }
                    }
                    updatePYHTandFavouriteBtns();
                });

                function inlineSVG($this){
                    var $svg = $(JSON.parse($this.find('.image').data('svg')));
                    if($this.data('level') == 'upper'){
                        $svg.find('[id]').each(function(){
                            $(this).attr('data-id', $(this).attr('id'));
                        });
                    }
                    $svg.children('g').each(function(){
                        $(this).attr('data-id', $(this).attr('id'));
                    });
                    $this.find('.image').append($svg);
                    $floorplanOptions.each(function(){
                        if($(this).hasClass('active')){
                            $svg.find('g[data-id$="'+$(this).data('option')+'"]').show();
                        }
                    });
                }

                if($flipToggle.filter(':visible').length > 0){
                    $flipToggle.filter(':visible').trigger('click');
                }else{
                    if($levels.filter(':visible').length > 0){
                        var level = $levels.filter('.active').data('level');
                        var $image = $floorplanImages.filter('[data-flipped="false"][data-level="'+level+'"].mobile');
                    }else{
                        var $image = $floorplanImages.filter('[data-flipped="false"]:not(.mobile)');
                    }
                    $image.addClass('active');
                    inlineSVG($image);
                }

                $floorplanOptions.on('click', function(){
                    var $svg = $floorplanImages.filter('.active').find('svg');
                    if($(this).hasClass('active')){
                        $(this).removeClass('active');
                        $svg.find('g[data-id$="'+$(this).data('option')+'"]').hide();
                    }else{
                        $(this).addClass('active');
                        var $svgOptions = $svg.find('g[data-id$="'+$(this).data('option')+'"]');
                        if($svgOptions.length){
                            $svgOptions.show();
                        }else if($levels.filter(':visible').length){
                            $levels.filter(':not(.active)').trigger('click');
                        }
                        $.each($(this).data('conflicts'), function(key, value){
                            if($floorplanOptions.filter('[data-id="'+value+'"]').hasClass('active')){
                                $floorplanOptions.filter('[data-id="'+value+'"]').trigger('click');
                            }
                        })
                    }
                    updatePYHTandFavouriteBtns()
                });

                $levels.on('click', function(){
                    $levels.removeClass('active');
                    $(this).addClass('active');
                    var flipped = $floorplanImages.filter('.active').data('flipped');
                    $floorplanImages.removeClass('active');
                    var $floorplanImage = $floorplanImages.filter('[data-level="'+$(this).data('level')+'"][data-flipped="'+flipped+'"]');
                    $floorplanImage.addClass('active');
                    $floorplanImages.find('.image').html('');
                    inlineSVG($floorplanImage);
                });

                $(window).resize(function(){
                    if($(window).outerWidth() >= 992 && $floorplanImages.filter('.active.mobile').length){
                        var flipped = $floorplanImages.filter('.active').data('flipped');
                        var $floorplanImage = $floorplanImages.filter('[data-flipped="'+flipped+'"]:not(.mobile)');
                        $floorplanImages.removeClass('active');
                        $floorplanImages.find('.image').html('');
                        $floorplanImage.addClass('active');
                        inlineSVG($floorplanImage);
                    }else if($(window).outerWidth() < 992
                        && $floorplanImages.filter('.active:not(.mobile)').length 
                        && $floorplanImages.filter('.mobile').length
                    ){
                        var flipped = $floorplanImages.filter('.active').data('flipped');
                        var level = $levels.filter('.active').data('level');
                        var $floorplanImage = $floorplanImages.filter('[data-flipped="'+flipped+'"][data-level="'+level+'"].mobile');
                        $floorplanImages.removeClass('active');
                        $floorplanImages.find('.image').html('');
                        $floorplanImage.addClass('active');
                        inlineSVG($floorplanImage);
                    }else if(!$flipToggle.length && $levels.filter(':visible').length){
                        var level = $levels.filter('.active').data('level');
                        var $floorplanImage = $floorplanImages.filter('[data-flipped="false"][data-level="'+level+'"].mobile');
                        $floorplanImages.removeClass('active');
                        $floorplanImages.find('.image').html('');
                        $floorplanImage.addClass('active');
                        inlineSVG($floorplanImage);
                    }else if(!$flipToggle.length){
                        var $floorplanImage = $floorplanImages.filter('[data-flipped="false"]:not(.mobile)');
                        $floorplanImages.removeClass('active');
                        $floorplanImages.find('.image').html('');
                        $floorplanImage.addClass('active');
                        inlineSVG($floorplanImage);
                    }
                });

                $popupTrigger.on('click', function(){
                    var $popup = $floorplan.find('.js-floorplan-popup');
                    if(!$popup.hasClass('open')){
                        var $overlay = $('<div class="js-floorplan-popup-overlay"></div>');
                        var $close = $('<div class="js-floorplan-popup-close"></div>');
                        $overlay.on('click', function(){
                            $overlay.remove();
                            $close.remove();
                            $popup.removeClass('open');
                            $('body').css('overflow','');
                        });
                        $close.on('click', function(){
                            $overlay.remove();
                            $close.remove();
                            $popup.removeClass('open');
                            $('body').css('overflow','');
                        });
                        $popup.append($overlay);
                        $popup.append($close);
                        $popup.addClass('open');
                        $('body').css('overflow','hidden');
                    }
                })

                function updatePYHTandFavouriteBtns(){
                    if($floorplanOptions.filter('.active').length){
                        var options_url_param = '&floorplan_options=[';
                        var options_json = ', floorplan_options: [';
                        $floorplanOptions.filter('.active').each(function(){
                            options_url_param += $(this).data('option') + ',';
                            options_json += $(this).data('option') + ',';
                        });
                        options_url_param = options_url_param.slice(0,-1)
                        options_json = options_json.slice(0,-1)
                        options_url_param += ']';
                        options_json += ']';
                        if($floorplanImages.filter('.active').data('flipped')){
                            options_url_param += '&flipped=1';
                            options_json += ', flipped: 1';
                        }else{
                            options_url_param += '&flipped=0';
                            options_json += ', flipped: 0';
                        }
                        $('.js-pyht-btn').attr('href', $('.js-pyht-btn').data('base-url') + options_url_param);
                        $('.js-favourite-btn').data('request-data', $('.js-favourite-btn').data('base-request-data') + options_json);
                    }else{
                        if($floorplanImages.filter('.active').data('flipped')){
                            var options_url_param = '&flipped=1';
                            var options_json = ', flipped: 1';
                        }else{
                            var options_url_param = '&flipped=0';
                            var options_json = ', flipped: 0';
                        }
                        $('.js-pyht-btn').attr('href', $('.js-pyht-btn').data('base-url') + options_url_param);
                        $('.js-favourite-btn').data('request-data', $('.js-favourite-btn').data('base-request-data') + options_json)
                    }
                }
            }

            var $homeDesignsCard = $('.js-home-design-card');
            if ($homeDesignsCard.length > 0) {

                $homeDesignsCard.each(function () {
                    let $parent = $(this)

                    $parent.find('.js-dropdown-options').on('change', function () {
                        toggleContent($parent, $(this).val())
                    })

                    $parent.find('.js-option').on('click', function () {
                        toggleContent($parent, $(this).data('target'))
                        $(this).addClass('active')
                    })

                    function toggleContent($parent, target) {
                        $parent.find('.js-option').removeClass('active')
    
                        $parent.find(`.js-content`).removeClass('active')
                        $parent.find(`.js-content.${target}`).addClass('active')
                    }
                })
            }
        });
    };

    return {
        init:init
    };
};

export default Floorplan;